import PageTemplate from "components/pageTemplate/PageTemplate";
import InlineModal from 'components/modal/InlineModal';
import ModalTitle from 'components/modal/components/ModalTitle';
import ModalFooter from 'components/modal/components/ModalFooter';
import getLocalizedText from 'helpers/getLocalizedText';
import InvoicesList from './list';
import InvoiceCreate from './create';

interface Props {
    onCloseCreateModal?: () => void;
    isCreate: boolean;
}

export const InvoicesWl19 = (props: Props) => {
    const { isCreate, onCloseCreateModal } = props;
    return (
        <PageTemplate.Main customClass='invoices-page'>
            <PageTemplate.Container
                customClass={isCreate && 'page-invoices'}>
                <InvoicesList />
                <InlineModal
                    isOpened={isCreate}
                    modalId='invoice-create'
                    onClose={() => onCloseCreateModal?.()}
                    onClickAwayClose={true}
                    needCloseButton={true}
                    customClassName='modal-invoice-create'>
                    <ModalTitle>{getLocalizedText('invoicing.newinvoice.tab')}</ModalTitle>
                    <InvoiceCreate />
                    <ModalFooter>{null}</ModalFooter>
                </InlineModal>
            </PageTemplate.Container>
        </PageTemplate.Main>
    );
};